export default __webpack_public_path__ + "static/media/associatedWords.0c61aad7.png";